import React from 'react';
import { Tasklist, TitleSection, Title, StatusIcon, OverLay } from '../../styles';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import { isEmpty, renderStatusIconName } from '../../../../../helpers/common';
import { MobxFilteredTasksListInterface } from '../../../../../interfaces/TaskInterface';
import { WorkspaceModel } from '../../../../../mobx/models/workspace';
import { ICON_SIZE, SHOW_TASK_GROUPING_TYPE } from '../../../../../global/constants';
import CollapseDropdown from '../../../../../component/dropdowns/collapseDropdown';

interface TaskGroupHeaderProps {
  item: MobxFilteredTasksListInterface;
  taskFilterGroupingStatus: number | undefined;
  isTemplateProject: boolean;
  loadData: () => void;
  currentWorkspace: WorkspaceModel | null;
  collapseIds: string[];
  handleCollapseClick: (id: string) => void;
}

export const TaskGroupHeader = React.memo(function TaskGroupHeader(props: TaskGroupHeaderProps) {
  const {
    item,
    taskFilterGroupingStatus,
    isTemplateProject,
    loadData,
    currentWorkspace,
    collapseIds,
    handleCollapseClick
  } = props;

  if (isEmpty(item?.name)) return null;

  return (
    <Tasklist>
      <TitleSection applyPadding={!!item?.status}>
        {taskFilterGroupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS && item?.status && (
          <StatusIcon>
            <SVGIcon
              name={renderStatusIconName(item?.status)}
              width={ICON_SIZE.MD}
              height={ICON_SIZE.MD}
              viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
            />
          </StatusIcon>
        )}
        <Title applyFontSize={taskFilterGroupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS}>
          {item?.name}
        </Title>
        {taskFilterGroupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS && item?.status && (
          <OverLay statusType={item?.status} />
        )}
      </TitleSection>

      {!isTemplateProject && (
        <CollapseDropdown
          groupDetail={item}
          loadData={loadData}
          workspaceDetail={currentWorkspace}
          collapseIds={collapseIds}
          setCollapse={handleCollapseClick}
        />
      )}
    </Tasklist>
  );
});

export default TaskGroupHeader;
